export const BASE_WEB_URL = 'https://bioportplus.jp'
export const BASE_WEB_CLINICS_URL = `${BASE_WEB_URL}/clinics`
